<template>
  <div v-if="$route.query.type == 'address' || $route.query.type =='ship-address'">
    <div class="edit-address-wrap emb-card pa-4">
      <h4 v-if="$route.query.type == 'ship-address'">{{editSection.Shipping_Label}}</h4>
      <h4 v-else>{{editSection.Billing_Label}}</h4>
      <div v-if="$route.query.type == 'ship-address'">
        <v-form ref="form" v-model="valid">
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field v-model="name" :label="editSection.Name_Placeholder"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field v-model="mobile" :label="editSection.Phone_Number_Placeholder"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field
                    v-model="buildingName"
                    :label="editSection.Building_Name_Placeholder"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field v-model="streetName" :label="editSection.Street_No_Placeholder"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-select
                    :label="editSection.Country_Label"
                    :items="countries"
                    v-model="country"
                    @change="onChange('country')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-select
                    :label="editSection.State_Label"
                    :items="states"
                    v-model="state"
                    @change="onChange('state')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-select
                    :label="editSection.City_Label"
                    :items="cities"
                    v-model="city"
                    @change="onChange('city')"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-select
                    :label="editSection.ZipCode_Label"
                    :items="zipcodes"
                    v-model="zipcode"
                    @change="onChange('zipcode')"
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs12 sm12 md4 lg4 xl4 py-2>
                  <p>{{editSection.Address_Type_Label}}</p>
                </v-flex>-->
                <v-flex xs6 sm6 md4 lg4 xl4 py-2>
                  <v-container fluid>
                    <p>{{ editSection.Address_Type_Label }}</p>
                    <v-radio-group v-model="addresstype" :mandatory="true" row>
                      <v-radio :label="editSection.Home_Label" :value="editSection.Home_Label"></v-radio>
                      <v-radio :label="editSection.Office_Label" :value="editSection.Office_Label"></v-radio>
                    </v-radio-group>
                  </v-container>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 py-2>
                  <v-checkbox v-model="checkbox" :label="editSection.CheckBox_Label"></v-checkbox>
                </v-flex>

                <v-flex xs12 sm12 md12 lg12 xl12 py-2>
                  <v-btn
                    class="accent mx-0 mb-4"
                    @click.stop.prevent="updateDetails"
                    type="shipping"
                  >{{editSection.Save_Button_Label}}</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex xs12 sm12 md6 lg6 xl6 reciept-bg edit-profile hidden-md-and-down></v-flex> -->
          </v-layout>
        </v-form>
      </div>
      <div v-else>
        <v-form>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field v-model="name" :label="editSection.Name_Placeholder"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field
                    v-model="buildingName"
                    :label="editSection.Building_Name_Placeholder"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <v-text-field v-model="streetName" :label="editSection.Street_No_Placeholder"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <!-- <v-select
                    @click="onChange('country')"
                    :label="editSection.Country_Label"
                    :items="countries"
                    v-model="country"
                  ></v-select>-->
                  <v-text-field v-model="country" :label="editSection.Country_Label"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <!-- <v-select
                    @change="onChange('state')"
                    :label="editSection.State_Label"
                    :items="states"
                    :value="state"
                    v-model="state"
                  ></v-select>-->
                  <v-text-field v-model="state" :label="editSection.State_Label"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <!-- <v-select @change="onChange('city')" :label="editSection.City_Label" :items="cities" v-model="city"></v-select> -->
                  <v-text-field v-model="city" :label="editSection.City_Label"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg6 xl6 py-2>
                  <!-- <v-select
                    :label="editSection.ZipCode_Label"
                    @change="onChange('zipcode')"
                    :items="zipcodes"
                    :value="zipcode"
                    v-model="zipcode"
                  ></v-select>-->
                  <v-text-field v-model="zipcode" :label="editSection.ZipCode_Label"></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 xl12 py-2>
                  <v-btn
                    class="accent mx-0 mb-4"
                    @click.stop.prevent="updateDetails1"
                    type="billing"
                  >{{editSection.Save_Button_Label}}</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex xs12 sm12 md6 lg6 xl6 reciept-bg edit-profile hidden-md-and-down></v-flex> -->
          </v-layout>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";

Vue.use(VueMoment, {
  moment,
});
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },

  data() {
    return {
      cmsRequestFunctions: null,
      editSection: "",
      name: "",
      buildingName: "",
      addresstype: "",
      streetName: "",
      state: "",
      zipcode: "",
      country: "",
      addressAdd: "",
      buildingNameAdd: "",
      shippingAddressData: [],
      streetNameAdd: "",
      stateAdd: "",
      cityAdd: "",
      zipcodeAdd: "",
      countryAdd: "",
      countryList: [],
      city: "",
      mobile: "",
      id: "",
      cities: [],
      countries: [],
      states: [],
      zipcodes: [],
      stateList: [],
      cityList: [],
      zipcodeList: [],
      valid: false,
      userName: "",
      checkbox: false,
      booleanDefalut: false,
      billlingID: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getData();
    this.readShippingAddress();
    this.readBillingAddress();
  },
  watch: {
    selectedLocale: function () {
      this.getData();
    },
  },
  methods: {
    onChange(value) {
      var self = this;
      if (value === "country") {
        self.state = "";
        self.zipcode = "";
        self.city = "";
      }
      if (value === "state") {
        self.zipcode = "";
        self.city = "";
      }
      if (value === "city") {
        self.zipcode = "";
      }

      self.countryList.forEach((element) => {
        if (
          element.Country_Name == self.country ||
          element.Country_Name == self.countryAdd
        ) {
          self.stateList = element.State_List;
        }
      });
      self.states.length = 0;
      self.stateList.forEach((element) => {
        self.states.push(element.State_Name);

        if (
          element.State_Name == self.state ||
          element.State_Name == self.stateAdd
        ) {
          self.cityList = element.City_List;
        }
      });
      self.cities.length = 0;
      self.cityList.forEach((element) => {
        self.cities.push(
          element.City_Name || element.City_Name == self.cityAdd
        );
        if (element.City_Name == self.city) {
          self.zipcodeList = element.Zipcode;
        }
      });
      self.zipcodes.length = 0;

      self.zipcodeList.forEach((element) => {
        self.zipcodes.push(element.Zipcode);
      });
    },
    saveDetails() {
      this.$refs.form.validate();
      if (this.valid == true) {
        this.$snotify.success(
          self.cmsRequestFunctions.getValidationMsgByCode("M014"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        setTimeout(() => {
          this.$router.push({
            path: "/account/address",
          });
        }, 50);
      }
    },
    getData() {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl: "17 Edit Address/17 Edit Address/17 Edit Address.ftl",
        lang: language,
        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var editArea = self.cmsRequestFunctions.pluck(
              "Edit_Address_Section",
              res.area_List
            );
            self.editSection = self.cmsRequestFunctions.getAllMapData(
              editArea[0].component
            );
            self.countryList = self.editSection.Country_List;
            self.addresstype = self.editSection.Home_Label;

            self.countryList.forEach((element) => {
              self.countries.push(element.Country_Name);
            });
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    readShippingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;

      var userName = self.loginDetails.loginId;

      var filterValue =
        "type='Shipping Address' AND keyword12='" + userName + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      this.fillData(allData, "shippingAddressData");
    },
    readBillingAddress: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;

      var userName = self.loginDetails.loginId;

      var filterValue1 =
        "type='Billing Address' AND keyword12='" + userName + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue1,
        "date1"
      );
      this.fillData(allData, "billingAddressData");
    },
    updateDetails: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;

      var userName = self.loginDetails.loginId;
      if (!self.name) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M015"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.buildingName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M018"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.streetName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M017"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.mobile) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M028"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      } else {
        // var phoneformat = /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/i;
        var phoneformat = /([+]?\d{5,8}[.-\s]?)?(\d{1}[.-]?){5}\d{0}/g;
        var match = self.mobile.match(phoneformat);
        if (match == null) {
          this.$snotify.warning(
            self.cmsRequestFunctions.getValidationMsgByCode("M031"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          self.isLoading = false;
          return false;
        }
      }
      if (!self.country) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M019"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.state) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M020"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }

      if (!self.city) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M022"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.zipcode) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M021"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );

        return false;
      }
      if (self.checkbox) {
        await self.updateDetails1();
      }
      self.id = self.$route.query.Id;
      if (self.id != "" && self.id != undefined) {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var sendingRequestup = {
          type: "Shipping Address",
          keyword3: self.streetName,
          keyword1: self.name,
          keyword4: self.buildingName,
          keyword5: self.zipcode,
          keyword6: self.state,
          keyword7: self.country,
          keyword8: self.mobile,
          keyword12: userName,
          keyword13: self.city,
          keyword15: self.addresstype,
          bool1: self.booleanDefalut,
          date1: requestedDate,
        };
        var dataid = self.id;
        let responseObject = await self.cmsRequestFunctions.cmsFormUpdateData(
          sendingRequestup,
          dataid
        );
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
        } catch (e) {
          console.log(e);
        }
        this.$snotify.success(
          self.cmsRequestFunctions.getValidationMsgByCode("M041"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        self.$router.push({
          path: "/account/address",
        });
      } else {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var boolValue = self.shippingAddressData.length < 1 ? true : false;
        var sendingRequest = {
          type: "Shipping Address",
          keyword1: self.name,
          keyword3: self.streetName,
          keyword4: self.buildingName,
          keyword5: self.zipcode,
          keyword6: self.state,
          keyword7: self.country,
          keyword8: self.mobile,
          keyword12: userName,
          keyword13: self.city,
          keyword15: self.addresstype,
          bool1: boolValue,
          date1: requestedDate,
        };
        let responseObject = await self.cmsRequestFunctions.cmsFormData(
          sendingRequest
        );
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
          this.readShippingAddress();
          this.readBillingAddress();
          this.$snotify.success(
            self.cmsRequestFunctions.getValidationMsgByCode("M041"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          self.$router.push({
            path: "/account/address",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    fillData(allData, attribute) {
      var self = this;
      self.id = self.$route.query.Id;
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        var addressData;
        attribute === "billingAddressData"
          ? (self.billingAddressData = allData.data.data)
          : (self.shippingAddressData = allData.data.data);

        attribute === "billingAddressData"
          ? (addressData = self.billingAddressData)
          : (addressData = self.shippingAddressData);

        for (const element of addressData) {
          if (attribute === "billingAddressData") {
            self.billlingID = element.id;
          }
          if (element.id != null && element.id == self.id) {
            self.streetName = element.keyword3;
            self.state = element.keyword6;
            self.country = element.keyword7;
            self.city = element.keyword13;
            self.addresstype = element.keyword15;
            self.zipcode = element.keyword5;
            self.buildingName = element.keyword4;
            self.mobile = element.keyword8;
            self.name = element.keyword1;
            if (attribute !== "billingAddressData") {
              self.booleanDefalut = element.bool1;
            }
            var stateList = [];
            var cityList = [];
            for (const coutry of self.countryList) {
              if (coutry.Country_Name == self.country) {
                stateList = coutry.State_List;
                for (const iterator of coutry.State_List) {
                  self.states.push(iterator.State_Name);
                }
              }
            }
            for (const state of stateList) {
              if (state.State_Name == self.state) {
                cityList = state.City_List;
                for (const iterator of state.City_List) {
                  self.cities.push(iterator.City_Name);
                }
              }
            }
            for (const cty of cityList) {
              if (cty.City_Name == self.city) {
                for (const iterator of cty.Zipcode) {
                  self.zipcodes.push(iterator.Zipcode);
                }
              }
            }
          }
        }
      } else {
        console.log("error:", allData);
      }
    },
    updateDetails1: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      self.userData = JSON.parse(user);
      self.loginDetails = self.userData.user_data;
      var userName = self.loginDetails.loginId;
      if (!self.name) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M015"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.buildingName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M018"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.streetName) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M017"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }

      if (!self.country) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M019"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }

      if (!self.state) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M020"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );

        return false;
      }

      if (!self.city) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M022"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }
      if (!self.zipcode) {
        this.$snotify.warning(
          self.cmsRequestFunctions.getValidationMsgByCode("M021"),
          {
            closeOnClick: false,
            pauseOnHover: false,
            timeout: 1000,
            showProgressBar: false,
          }
        );
        return false;
      }

      self.id = self.$route.query.Id;
      if (self.checkbox) {
        self.id = self.billlingID;
      }
      if (self.id != "" && self.id != undefined) {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var sendingRequestup = {
          type: "Billing Address",
          keyword3: self.streetName,
          keyword1: self.name,
          keyword4: self.buildingName,
          keyword5: self.zipcode,
          keyword6: self.state,
          keyword7: self.country,
          keyword12: userName,
          keyword13: self.city,
          date1: requestedDate,
        };
        var dataid1 = self.id;
        let responseObject = await self.cmsRequestFunctions.cmsFormUpdateData(
          sendingRequestup,
          dataid1
        );
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
          this.$snotify.success(
            self.cmsRequestFunctions.getValidationMsgByCode("M042"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          if (!self.checkbox) {
            self.$router.push({
              path: "/account/address",
            });
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        let requestedDate = moment(String(new Date())).format(
          "YYYY-MM-DDThh:mm:ss"
        );
        var sendingRequest = {
          type: "Billing Address",
          keyword3: self.streetName,
          keyword1: self.name,
          keyword4: self.buildingName,
          keyword5: self.zipcode,
          keyword6: self.state,
          keyword7: self.country,
          keyword12: userName,
          keyword13: self.city,
          date1: requestedDate,
        };
        let responseObject = await self.cmsRequestFunctions.cmsFormData(
          sendingRequest
        );
        try {
          let insertID = Number(responseObject);
          console.log(insertID);
          this.readBillingAddress();
          this.$snotify.success(
            self.cmsRequestFunctions.getValidationMsgByCode("M042"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
          if (!self.checkbox) {
            self.$router.push({
              path: "/account/address",
            });
          }

          //   var emailApi = ServiceUrls.emailServices.emailApi;
          //   sendMailService(emailApi, postData);
          //   sendMailService(emailApi, custmail);
        } catch (e) {
          console.log(e);
        }
      }
    },
  },
};
</script>